/**
 * TicketStub copy + animation timings. Kept here so component file stays terse.
 */

/**
 * Feature flag for the "Get the app" CTA on invite landing cards.
 *
 * OFF: there is no deferred deep link, so a visitor who taps it, installs from
 * the store, and opens the app lands with no invite context — they must re-open
 * the original link or enter the squad code manually. Steer invitees through
 * "Create Account & Join" on web (returnUrl + pending join handlers) instead.
 */
export const SHOW_CONTINUE_WITH_APP_CTA = false;

export const TICKET_STUB_COPY = {
  HEADER_INVITED: "You're invited",
  TEAR_HINT: 'TEAR HERE',
  STAT_MATCHES_LABEL: 'Matches',
  STAT_LOCKS_LABEL: 'Locks in',
  /**
   * Shown once the first kickoff has passed. Not "Locked": a squad invite is still joinable
   * after a competition starts (specs/worldcup-late-join), and the latecomer still picks every
   * remaining match — "Locked" told them the opposite.
   */
  LOCKS_PAST_LABEL: 'Under way',
  /** A competition that has already been played out. */
  LOCKS_FINISHED_LABEL: 'Finished',
  GROUP_CODE_LABEL: 'Group code',
  STUB_KICKER: 'The Office Cup',
  REVEAL_SUFFIX: 'colleagues',
  /** Appended to the reveal line only when the match count is known, e.g. "· 153 matches to predict". */
  REVEAL_MATCHES_SUFFIX: 'matches to predict',
  CONTINUE_WITH_APP: 'Get the app',
} as const;

/** Stable hooks for the stats block, whose cells are conditional (specs/champions-league Story 20). */
export const TICKET_STUB_TEST_IDS = {
  stats: 'ticket-stub-stats',
  matches: 'ticket-stub-stat-matches',
  locks: 'ticket-stub-stat-locks',
} as const;

export const ACCENT_GOLD = '#FFCB47';
export const ACCENT_GREEN = '#4ADE9B';

export const BARCODE_SEED = [2, 1, 3, 1, 2, 1, 1, 2, 3, 1, 2, 2, 1, 3, 1, 2, 1, 1, 2, 3, 1, 1, 2, 3, 1, 2, 1] as const;

export const CONFETTI_COUNT = 14;

/** Burst geometry — fixed per index so layout is deterministic. */
export const CONFETTI_PIECES = Array.from({ length: CONFETTI_COUNT }, (_, i) => {
  const angle = (i / CONFETTI_COUNT) * Math.PI * 2;
  const dist = 80 + (i % 3) * 30;
  return {
    dx: Math.cos(angle) * dist,
    dy: Math.sin(angle) * dist - 6,
    rotate: (i % 2 === 0 ? 1 : -1) * (420 + (i % 4) * 40),
  };
});

export const TICKET_STUB_TIMINGS = {
  /** Top stub fly-off duration; the success reveal crossfades in during this. */
  TEAR_MS: 900,
  /** How long the success reveal stays on-screen after the tear before nav. */
  REVEAL_HOLD_MS: 700,
} as const;

export const TICKET_STUB_LAYOUT = {
  FRAME_MAX_WIDTH: 420,
  STUB_FLY_Y: -340,
  STUB_FLY_X: -38,
  STUB_FLY_ROTATE_DEG: -22,
} as const;
